import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { fetchBoardTypeList, fetchBoardList, fetchBoardListQna, fetchBoardItemList, fetchBoardItemListFaq, fetchBoardItem, postBoardItem, putBoardItem, deleteBoardItem, putBoardReplyItem, deleteBoardReplayItem, } from ".";
import { isDebug } from "../../utils";


export const useBoardListQuery = (queryOptions) => {
  return useQuery({
    queryKey: ["board-of-list", queryOptions],
    queryFn: () => fetchBoardList(queryOptions),
    select: (response) => {
      return response.data || {};
    },
    onError: (error) => {
      console.error("Error fetching Board List API contracts:", new Date().toISOString(), error);
    },
    staleTime: 1000 *  process.env.REACT_APP_USE_QUERY_STALE_TIME, // env Value default(1)
    refetchOnWindowFocus: false,
  });
};

export const useBoardListQnaQuery = (queryOptions) => {
  return useQuery({
    queryKey: ["board-of-list-qna", queryOptions],
    queryFn: () => fetchBoardListQna(queryOptions),
    select: (response) => {
      return response.data || {};
    },
    onError: (error) => {
      console.error("Error fetching Board List API contracts:", new Date().toISOString(), error);
    },
    staleTime: 1000 *  process.env.REACT_APP_USE_QUERY_STALE_TIME, // env Value default(1)
    refetchOnWindowFocus: false,
  });
};

export const useBoardItemListQuery = (queryOptions) => {
  return useQuery({
    queryKey: ["board-item-of-list", queryOptions],
    queryFn: () => fetchBoardItemList(queryOptions),
    select: (response) => {
      return response.data || {};
    },
    onError: (error) => {
      console.error("Error fetching Board item List API contracts:", new Date().toISOString(), error);
    },
    staleTime: 1000 *  process.env.REACT_APP_USE_QUERY_STALE_TIME, // env Value default(1)
    refetchOnWindowFocus: false,
  });
};

export const useBoardItemListFaqQuery = (queryOptions) => {
  return useQuery({
    queryKey: ["board-item-of-list-faq", queryOptions],
    queryFn: () => fetchBoardItemListFaq(queryOptions),
    select: (response) => {
      return response.data || {};
    },
    onError: (error) => {
      console.error("Error fetching Board Faq item List API contracts:", new Date().toISOString(), error);
    },
    staleTime: 1000 *  process.env.REACT_APP_USE_QUERY_STALE_TIME, // env Value default(1)
    refetchOnWindowFocus: false,
  });
};

export const useBoardItemQuery = (manage_id, board_id) => {
  return useQuery({
    queryKey: ["board-of-item", {manage_id, board_id}],
    queryFn: () => fetchBoardItem(manage_id, board_id),
    select: (response) => {
        return response.data.data || [];
    },
    onError: (error) => {
      console.error("Error fetching Board item API contracts:", new Date().toISOString(), error);
    },
    staleTime: 1000 *  process.env.REACT_APP_USE_QUERY_STALE_TIME, // env Value default(1)
    refetchOnWindowFocus: false,
    enabled: (manage_id > 0 && board_id > 0),
  });
};

export const useBoardItemPostMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: postBoardItem,
    onSuccess: () => {
      if (isDebug()) console.log("#@#@ Board Article posted successfully!", new Date().toISOString());
      queryClient.invalidateQueries(["post-board-item"]);
    },
    onError: (error) => {
      console.error("#@#@ Failed to post Board Article :", new Date().toISOString(), error);
    },
  });
};

export const useBoardItemPutMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: putBoardItem,
    onSuccess: () => {
      if (isDebug()) console.log("#@#@ Board Article put successfully!", new Date().toISOString());
      queryClient.invalidateQueries(["put-board-item"]);
    },
    onError: (error) => {
      console.error("#@#@ Failed to put Board Article :", new Date().toISOString(), error);
    },
  });
};

export const useBoardItemDeleteMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: deleteBoardItem,
    onSuccess: () => {
      if (isDebug()) console.log("#@#@ Board Article deleted successfully!", new Date().toISOString());
      queryClient.invalidateQueries(["delete-board-item"]);
    },
    onError: (error) => {
      console.error("#@#@ Failed to delete Board Article :", new Date().toISOString(), error);
    },
  });
};

export const useBoardReplyItemPutMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: putBoardReplyItem,
    onSuccess: () => {
      if (isDebug()) console.log("#@#@ Board Article Reply put successfully!", new Date().toISOString());
      queryClient.invalidateQueries(["put-board-item"]);
    },
    onError: (error) => {
      console.error("#@#@ Failed to Reply put Board Article :", new Date().toISOString(), error);
    },
  });
};

export const useBoardReplyItemDeleteMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: deleteBoardReplayItem,
    onSuccess: () => {
      if (isDebug()) console.log("#@#@ Board Article Reply deleted successfully!", new Date().toISOString());
      queryClient.invalidateQueries(["delete-board-item"]);
    },
    onError: (error) => {
      console.error("#@#@ Failed to Reply delete Board Article :", new Date().toISOString(), error);
    },
  });
};